import { useParams } from "react-router";
import useEventDetails from "./hooks/useEventDetails";
import FullLoading from "../../../../components/FullLoading";
import Redirect from "../../../../components/Redirect";
import EventDetails from "../../../../components/EventDetails";
import { EventFragment } from "../../../../__generated__/graphql";
import { ChevronRightIcon, StarIcon } from "@heroicons/react/24/outline";

export default function EventPage() {
  const { id } = useParams();
  const { data, loading, error } = useEventDetails(id);

  if (loading) {
    return <FullLoading />;
  }

  if (!data || !data.event || error) {
    return <div className="text-2xl font-bold">Cet évènement n'existe pas</div>;
  }

  if (data.event?.projectId) {
    return (
      <Redirect
        to={`/projects/${data.event.projectId}?eventId=${data.event.id}`}
      />
    );
  }

  const eventHeader = (event: EventFragment) => {
    return (
      <div className="flex items-center gap-2">
        <div className="text-sm text-secondary">Évènements</div>

        <ChevronRightIcon className="w-4 h-4 text-secondary" />

        <div className="flex items-center gap-2 border border-input  rounded-md p-2 ">
          <StarIcon className="w-4 h-4 text-accent" />

          <div className="text-sm text-primary">{event.name}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-4">
      {eventHeader(data.event)}
      <EventDetails event={data.event} refetchProjectDetails={() => {}} />
    </div>
  );
}
